module.exports = __webpack_public_path__ + "static/media/halugen_kit_items.2624e226.png";